import { PermissionKey, PermissionsMap } from '../types';

class PortalLevelPermissions {
  permissionsMap: PermissionsMap = {};

  public initialize(permissionsMap: PermissionsMap) {
    this.permissionsMap = permissionsMap;
  }

  /**
   * Checks if a specific permission is enabled for a given portal.
   * If no portalId is provided, it checks if the permission is at least at one portal.
   * If entity does not have portal association, portal should be passed as null. F.e for assets. 
   *
   */
  public isPermissionEnabled(
    permissionKey: PermissionKey,
    portalId?: number | null
  ): boolean {
    const permissionValue = this.permissionsMap[permissionKey];
    if (permissionValue === 'all') return true;

    if (portalId === null) {
      return !!permissionValue;
    }

    return portalId ? !!permissionValue?.includes(portalId)
      : !!permissionValue?.length;
  }

  public reset() {
    this.permissionsMap = {};
  }
}

export const portalLevelPermissions = new PortalLevelPermissions();